import { Component, OnInit, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import 'rxjs/add/operator/finally';
import { Logger } from '../core';
import { Firmas, OrdenTabs, QRDocument } from '../shared/models/qr-document.model';
import { isEmpty, find, findIndex } from 'lodash';
import { environment } from '@env/environment';
import { ActivatedRoute } from '@angular/router';
import { QRDocumentsPageDataService } from './shared/qr-documents-page.data.service';
import { QRDocumentsPageConfigService } from './shared/qr-documents-page.config.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs/tabset.component';


const log = new Logger('qr-document');

interface OrderTabsView extends OrdenTabs {
  view: boolean;
  complete?: boolean;
  active?:boolean
}

interface LabelsDocument {
  label: string;
  value?: string;
  orden: number;
}

@Component({
  selector: 'iw-qr-document',
  templateUrl: './qr-documents-page.component.html',
  styleUrls: ['./qr-documents-page.component.scss'],
  providers: [QRDocumentsPageDataService]
})
export class QRDocumentsPageComponent implements OnInit, OnDestroy {
  private code: string;
  private sub: any;
  constructor(
    private ppds: QRDocumentsPageDataService,
    private route: ActivatedRoute
  ) { }
  // Datos para llenar la tabla de firmas
  sourceData: Firmas[];
  // configuraciones de la tabla de firmas
  settings = {};
  // Datos para llenar la tabla de prestamo
  sourceDataDocumentLoan: any[];
  // configuraciones de la tabla de prestamo
  settingsDocumentLoan = {};
  // Datos para llenar la tabla de contenido
  sourceDataContent: any[];
  // configuraciones de la tabla de contenido
  settingsDoContent = {};
  // documento
  document: any;
  // Asunto del documento
  description: string = "";
  // Nombre del documento:
  docName: string = "";
  // Atajo a las configuraciones del entorno de ejecución
  env = environment;
  // valida si hay informacion para mostrar
  valid: boolean = true;
  // Define cuando muestra o oculta el tab de prestamo
  tabDocumentLoan = false;
  // Define cuando muestra o oculta el tab de contenido
  tabContent = false;
  // Define si el formularios es de firmas o de tabs de informacion
  signatrueForm = false;
  // Contiene el orden de las pestañas
  orderTabs: OrderTabsView[] = [
    {
      orden: 1,
      pestana: 'firmas',
      requerido: false,
      nombre: 'Historial de firmas o aprobaciones',
      view: false,
      modificable: false
    },
    {
      orden: 2,
      pestana: 'prestamo',
      requerido: false,
      nombre: 'Historial prestamo',
      view: false,
      modificable: false
    },
    {
      orden: 3,
      pestana: 'contenido',
      requerido: false,
      nombre: 'Historial de contenido',
      view: false,
      modificable: false
    }
  ];
  // Define si el formulario de informacion de documento es dinamico o no
  dynamicInfo = false;
  // Define los titulos dinamicos para el documento
  labels: LabelsDocument[] = [];

  @ViewChildren(TabsetComponent) staticTabs: QueryList<TabsetComponent>;


  ngOnInit(): void {
    log.debug(this.route.snapshot.queryParamMap);
    this.sub = this.route.params.subscribe(params => {
      this.code = params['code'];
   });
    this.getQRdocument(this.code);
    const configTable = new QRDocumentsPageConfigService();
    this.settings = configTable.settings;
  }

  async getQRdocument(code:string) {
    let dataTable: QRDocument;
    await this.ppds.getQRdocument(code).subscribe(doc =>{
      dataTable = doc;
      if(dataTable && !isEmpty(dataTable)){
        if(dataTable.vista_firmas){
          this.signatrueForm = true;
          let tab = find(this.orderTabs, {pestana: 'firmas'});
          tab.view = true;
          if (dataTable.firmas.length){
            this.sourceData = dataTable.firmas;
          }
          if(dataTable.documento){
              this.docName = dataTable.documento;
          }
          if(dataTable.asunto){
            this.description = dataTable.asunto;
          }
        }else{
          this.signatrueForm = false;
          let tabIndex = findIndex(this.orderTabs, {pestana: 'firmas'});
          this.orderTabs.splice(tabIndex,1);
        }
        if(dataTable.historial_prestamo){
          this.tabDocumentLoan = true;
          let configTable = new QRDocumentsPageConfigService();
          this.settingsDocumentLoan = configTable.baseSettings;
          if(dataTable.historial_prestamo.estructura && dataTable.historial_prestamo.estructura.length){
            let valueInfo = dataTable.historial_prestamo.estructura.sort((a, b) => { return a.orden - b.orden})
            valueInfo.forEach(e=>{
              this.settingsDocumentLoan['columns'][e.alias] = {
                editable: false,
                addable: false,
                title: e.nombre,
                filter: {
                  inputClass: 'form-control',
                }
              }
            });
          }
          if(dataTable.historial_prestamo.valores){
            this.sourceDataDocumentLoan = dataTable.historial_prestamo.valores;
          }
          
          let tab = find(this.orderTabs, {pestana: 'prestamo'});
          tab.view = true;
        }else{
          this.tabDocumentLoan = false;
          let tabIndex = findIndex(this.orderTabs, {pestana: 'prestamo'});
          this.orderTabs.splice(tabIndex,1);
        }
        if(dataTable.historial_contenido){
          let configTable = new QRDocumentsPageConfigService();
          this.settingsDoContent = configTable.baseSettings;
          if(dataTable.historial_contenido.estructura && dataTable.historial_contenido.estructura.length){
            let valueInfo = dataTable.historial_contenido.estructura.sort((a, b) => { return a.orden - b.orden})
            valueInfo.forEach(e=>{
              this.settingsDoContent['columns'][e.alias] = {
                editable: false,
                addable: false,
                title: e.nombre,
                filter: {
                  inputClass: 'form-control',
                }
              }
            });
          }
          if(dataTable.historial_contenido.valores){
            this.sourceDataContent = dataTable.historial_contenido.valores;
          }
          let tab = find(this.orderTabs, {pestana: 'contenido'});
          tab.view = true;
          this.tabContent = true;
        }else{
          this.tabContent = false;
          let tabIndex = findIndex(this.orderTabs, {pestana: 'contenido'});
          this.orderTabs.splice(tabIndex,1);
        }
        if(dataTable.informacion){
          this.dynamicInfo = true;
          if(dataTable.informacion.estructura && dataTable.informacion.estructura.length){
            let valueInfo = dataTable.informacion.estructura.sort((a, b) => { return a.orden - b.orden})
          valueInfo.forEach(e=>{
            let value = "";
            if (dataTable.informacion.valores && dataTable.informacion.valores.length){
              value = dataTable.informacion.valores[0][e.alias];
            }
            let labelResult = {"label":e.nombre, "orden":e.orden,"value":value};
            this.labels.push(labelResult);
          });
          }
          
        }
        if(this.orderTabs.length){
          this.orderTabs[0].active = true;
        }
        
        
      }else{
        this.valid = false;
      }
    },err=>{
      this.valid = false;
    }
    )

  }

    /**
   * Mantiene las pestañas sincronizadas
   *
   * @param {number} tabId
   * @param {boolean} [staticTab=true]
   * @memberof QRDocumentsPageComponent
   */
     selectTab(tabId: number, staticTab: boolean = true) {
      if (this.staticTabs && this.staticTabs.length) {
        if (staticTab) {
          this.staticTabs.first.tabs[tabId].active = true;
        } else {
          this.staticTabs.last.tabs[tabId].active = true;
        }
      }
    }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/qr-documents-page/qr-documents-page.component.ts